// import fetch from 'lib/decorated-fetch'
// import { ServiceId } from '@byted-motor/upload'
import cookie from 'cookie'
import MotorUploader, {
  GetImageUrlOptions,
  GetImageUrlRes,
} from '@byted-motor/upload/lib/uploader'
// 上传SDK文档地址 https://code.byted.org/motor-fe/byted-motor-fe/blob/feat-uploader/packages/upload/README.md

let uploader: MotorUploader

async function getUploader() {
  if (uploader) {
    return uploader
  }

  const { MotorUploader } = await import('@byted-motor/upload')

  let userId = 'motor_user_default'
  try {
    userId = JSON.parse(cookie.parse(document.cookie)?.user_data)?.userId
  } catch (e) {
    //
  }

  uploader = new MotorUploader({
    // 建议设置能识别用户的唯一标识id，用于上传出错时排查问题，不要传入非 ASCII编码
    userId,
    imageHost: null as any,
    region: 'cn',
    // 视频上传配置
    // videoConfig: {
    //
    // }
  })

  return uploader
}

export async function uploadImg(file: File) {
  const uploader = await getUploader()
  const res = await uploader.uploadImage(file)
  const { uploadResult } = res || {}
  return {
    uri: uploadResult?.Uri,
    width: uploadResult?.ImageWidth,
    height: uploadResult?.ImageHeight,
    format: uploadResult?.ImageFormat,
    size: uploadResult?.ImageSize,
  }
}
// tos-cn-i-f042mdwyw7/4f2645635a1f4f1690f2eeed2d64e466
/**
 * 上传单张图片
 */
// const uploadImg = async ({
//   file,
//   resolve,
//   reject,
// }: {
//   file: File
//   resolve: any
//   reject: any
// }) => {
//   try {
//     const json = await fetch('/motor/car_user/v1/get_normal_auth/')
//     // @ts-ignore
//     const ByteVideoUpload = (await import('byted-video-uploader')).default
//     const byteVideoUploader = new ByteVideoUpload({
//       debug: true,
//       department: json.access_key, // 业务id,需要向视频架构组申请
//       // user_id: '109005472317', // 业务方的user_id
//       vasDomain: 'https://vas.snssdk.com',
//       logDomain: 'https://log.snssdk.com',
//       coverTime: 0, // 封面截图时间
//       retryUploadTime: 5,
//       retryProcessTime: 5,
//       retryTaskTime: 5,
//       maxProcessPause: 20,
//       uploadSliceCount: 5,
//       source: 8,
//       source_v2: 10,
//     })
//     const fileKey = byteVideoUploader.addFile({
//       file,
//       name: 'dcd_upload_image',
//       auth: json.data, // 具有时效性，每次上传前通过业务获取
//       type: 'image', // 上传文件类型，两个可选值：video(视频或者音频)，image(图片)
//     })
//     byteVideoUploader.start(fileKey)
//     byteVideoUploader.on('complete', (info: any) => {
//       resolve(info.image)
//     })
//     byteVideoUploader.on('error', (info: any) => {
//       reject('上传失败 无法解析文件')
//       console.error(info)
//     })
//   } catch {
//     reject('上传失败，请检查网络是否正常')
//   }
// }
/**
 * 获取图片Blob
 */
export const getImageBlob = (url: string) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('get', url, true)
    xhr.responseType = 'blob'
    xhr.onload = function () {
      if (this.status === 200) {
        resolve(this.response)
      }
    }
    xhr.onerror = function () {
      reject(new Error())
    }
    xhr.send()
  })
}

/**
 * 上传图文列表
 */
export function uploadImgList(imgList: File[]) {
  return Promise.allSettled(imgList.map((item) => uploadImg(item))).then(
    (result) => result.map((d) => (d.status === 'fulfilled' ? d.value : null))
  )
}

/**
 * 通过uri 获取 url
 **/
export async function getImageUrl(
  imgUris: string[],
  options?: GetImageUrlOptions
): Promise<GetImageUrlRes['img_url_map']> {
  const uploader = await getUploader()

  const res = await uploader.getImageUrl(imgUris, options)
  // console.log(res.img_url_map['tos-cn-i-f042mdwyw7/4f2645635a1f4f1690f2eeed2d64e466'].main_url)
  return res.img_url_map
}
